import { FormGroup } from "@angular/forms";
import { FormValidators } from "./validation/form.validator";

export class Utils {

    static noImage = 'assets/images/no_img.png';

    static convertThumbnail(url: string, size = 't') {
        return `https://api.pagepeeker.com/v2/thumbs.php?size=${size}&url=${url}`;
    }

    static inputNumberOnly() {
        $('#numberField').on('keypress', (e) => {
            // if the letter is not digit or dot, then don't display anything
            if (e['which'] !== 46 && e['which'] > 31 && (e['which'] < 48 || e['which'] > 57)) {
                return false;
            }
        });
    }

    static openVideo(src: any) {
        const modal = document.getElementById('videoModal');
        const modalVideo: any = document.getElementById("videoContent");
        modal.style.display = "block";
        modalVideo.src = src?.changingThisBreaksApplicationSecurity || src;
        modalVideo.play();
    }

    static openImage(src: any) {
        const modal = document.getElementById('imageModal');
        const modalImg: any = document.getElementById("imgContent");
        modal.style.display = "block";
        modalImg.src = src?.changingThisBreaksApplicationSecurity || src;
    }

    static isOtherType(contentType: string) {
        // To check the content type other then image,audio and video
        if (contentType.includes("audio") || contentType.includes("video") || contentType.includes("image")) {
            return false;
        } else { return true; }
    }

    static downloadFileByUrl(url: string) {
        window.open(url, "_blank");
    }

    static getError(errors: any) {
        return Object.values(errors);
    }

    static closeVideo() {
        const modalVideo: any = document.getElementById("videoContent");
        modalVideo.pause();
        modalVideo.currentTime = 0;
        const modal = document.getElementById('videoModal');
        modal.style.display = "none";
    }

    static closeImage() {
        const modal = document.getElementById('imageModal');
        modal.style.display = "none";
    }

    static initSearchProject() {
        $('#searchBarTitle').hide();
        $('#searchBar').show();
    }

    static closeSearchBar() {
        $('#searchBar').hide();
        $('#searchBarTitle').show();
    }

    static toMidnight(input: Date) {

        const date = new Date(input);

        const day = date.getDate();
        const month = date.getMonth();
        const year = date.getFullYear();

        const newDate = new Date(year, day, month);
        return newDate.setHours(0, 0, 0, 0);
    }

    static getErrorMessage(controlName: string, form: FormGroup) {
        const control = form.get(controlName);
        const errorMessages = [
            { code: "PasswordTooShort", description: "Password requires at least '{0}' characters" },
            { code: "PasswordRequiresDigit", description: "Password requires at least 1 numeric character" },
            { code: "PasswordRequiresLower", description: "Password requires at least 1 lower case character" },
            { code: "PasswordRequiresUpper", description: "Password requires at least 1 upper case character" },
            { code: "PasswordRequiresNonAlphanumeric", description: "Password requires at least 1 symbol" }
        ];
        const validationMessage = FormValidators.CustomPasswordValidator.GetErrorMessage(control, errorMessages);

        if (control.hasError("required") && controlName == "newPassword") {
            return validationMessage.replace("{0}", "New Password");
        }

        return validationMessage;
    }
}
